import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Building2 } from 'lucide-react';

interface CompanyDescriptionProps {
  companyName: string;
  description: string;
  vision: string;
  mission: string;
}

const SectionContainer = styled(Box)(({ theme }) => ({
  background: 'rgba(26, 26, 46, 0.6)',
  backdropFilter: 'blur(10px)',
  borderRadius: theme.spacing(2),
  border: '1px solid rgba(138, 43, 226, 0.2)',
  padding: theme.spacing(3),
  marginBottom: theme.spacing(4),
  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  color: '#fff',
  marginBottom: theme.spacing(2),
  fontWeight: 600,
}));

const SectionContent = styled(Typography)(({ theme }) => ({
  color: 'rgba(255, 255, 255, 0.7)',
  marginBottom: theme.spacing(2),
}));

const CompanyDescription: React.FC<CompanyDescriptionProps> = ({
  companyName,
  description,
  vision,
  mission,
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Building2 size={20} color="#8A2BE2" style={{ marginRight: 8 }} />
        <Typography variant="h5" sx={{ color: '#fff' }}>
          Company Description & Vision
        </Typography>
      </Box>

      <SectionContainer>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SectionTitle variant="h6">{companyName}</SectionTitle>
            <SectionContent variant="body2">{description}</SectionContent>
          </Grid>

          <Grid item xs={12} md={6}>
            <SectionTitle variant="subtitle1">Vision</SectionTitle>
            <SectionContent variant="body2">{vision}</SectionContent>
          </Grid>

          <Grid item xs={12} md={6}>
            <SectionTitle variant="subtitle1">Mission</SectionTitle>
            <SectionContent variant="body2">{mission}</SectionContent>
          </Grid>
        </Grid>
      </SectionContainer>
    </Box>
  );
};

export default CompanyDescription; 